import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const escapeHtml = (value) =>
	String(value ?? "")
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#039;");

const normalizeMessage = (message) => {
	if (message instanceof Error) return message.message || "Something went wrong.";
	if (typeof message === "object" && message !== null) {
		try {
			return JSON.stringify(message, null, 2);
		} catch (e) {
			return String(message);
		}
	}
	return String(message ?? "");
};

const toSafeHtml = (message) => escapeHtml(normalizeMessage(message)).replace(/\n/g, "<br/>");

let alertQueue = Promise.resolve();

const enqueueSwal = (runner) => {
	alertQueue = alertQueue.catch(() => undefined).then(runner);
	return alertQueue;
};

export const sweetConfirm = (message, options = {}) => {
	const safeHtml = toSafeHtml(message);

	return enqueueSwal(async () => {
		const result = await Swal.fire({
			title: options.title || "Please Confirm",
			html: `<div class="cs-alert-message">${safeHtml}</div>`,
			icon: options.icon || "warning",
			iconColor: "#FF8C00",
			showCancelButton: true,
			confirmButtonText: options.confirmButtonText || "Yes",
			cancelButtonText: options.cancelButtonText || "Cancel",
			allowOutsideClick: false,
			allowEscapeKey: true,
			buttonsStyling: false,
			customClass: {
				popup: "cs-swal-popup",
				title: "cs-swal-title",
				confirmButton: "cs-swal-confirm-btn",
				cancelButton: "cs-swal-cancel-btn",
			},
		});

		return !!result.isConfirmed;
	});
};

export const setupSweetAlertForNativeAlert = () => {
	if (typeof window === "undefined" || window.__sweetAlertPatched__) return;

	window.__nativeAlert__ = window.alert;

	window.alert = (message) => {
		// const safeHtml = escapeHtml(normalizeMessage(message)).replace(/\n/g, "<br/>");
		const safeHtml = toSafeHtml(message);

		alertQueue = alertQueue
			.catch(() => undefined)
			.then(() =>
				Swal.fire({
					title: "Notice",
					html: `<div class="cs-alert-message">${safeHtml}</div>`,
					icon: "info",
					iconColor: "#FF8C00",
					confirmButtonText: "OK",
					allowOutsideClick: false,
					allowEscapeKey: true,
					buttonsStyling: false,
					customClass: {
						popup: "cs-swal-popup",
						title: "cs-swal-title",
						confirmButton: "cs-swal-confirm-btn",
					},
				}),
			);

		return undefined;
	};

	window.__sweetAlertPatched__ = true;
};
